import React, { Component } from "react";
import "./Categories.css";
import axios from "axios";
import { Link } from "react-router-dom";
import Util from "../../util/util";
import { useLanguage } from "../../contexts/LanguageContext";

class Categories extends Component {
  constructor(ttt) {
    super();
    this.state = { allCategories: [] };
  }

  componentDidMount() {
    document.title = "Sve kategorije " + this.props.pageTitle;

    var mainThis = this;
    axios
      .post(window.ajaxLink + "products/categories", {})
      .then((res) => {
        if (
          res["data"] &&
          res["data"]["responseData"] &&
          res["data"]["responseData"]["categories"]
        ) {
          mainThis.setState({
            allCategories: res["data"]["responseData"]["categories"],
          });
        }
      })
      .catch((err) => {});
  }

  render() {
    const path = (path) => this.props.getPathWithLanguage ? this.props.getPathWithLanguage(path, this.props.currentLanguage) : path;

    return (
      <div className="categories_page">
        <div className="categories_title">Sve kategorije</div>
        {this.state.allCategories.map((oneItem, j) => (
          <div className="category_oneitem" key={j}>
            <div className="category_topname">
              <Link to={path(oneItem.link)}>
                {Util.firstLettersUppercase(oneItem.name)}
              </Link>
            </div>
            <div className="category_subname">
              {oneItem.sub_categories.map((oneSubItem, jj) => (
                <div key={jj}>
                  <Link to={path(oneSubItem.link)}>
                    {Util.firstLettersUppercase(oneSubItem.name)}
                  </Link>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }
}

const CategoriesWithLanguage = (props) => {
  const { currentLanguage, getPathWithLanguage } = useLanguage();

  return (
    <Categories
      {...props}
      currentLanguage={currentLanguage}
      getPathWithLanguage={getPathWithLanguage}
    />
  );
};

export default CategoriesWithLanguage;
